import type React from "react";
import type { AppSlug } from "@app/portal-sdk";

/**
 * MNT-1: the component behind each maintained thing the registry declares `maintainedBy: "screen"`, keyed by
 * application slug and thing key. The shell mounts these on /admin/apps/:slug; nothing else routes to them.
 * maintenance.test.ts holds this map and the registry to each other: a declared screen with no component here fails,
 * and a component here with no declaration fails, the way the unlisted-suite guard treats a test nobody listed. A thing
 * maintained elsewhere may have a read-only view here; it may not have a control.
 */
export type MaintenanceTab = React.ComponentType;

import LibraryAdmin from "../dueDiligence/LibraryAdmin";
import QueueAdmin from "../dueDiligence/QueueAdmin";
import SeedFileAdmin from "../dueDiligence/SeedFileAdmin";
import { ChannelAnalyticsExample } from "./ChannelAnalyticsExample";
import { VoiceOfCustomerLibrary } from "./VoiceOfCustomerLibrary";

/**
 * MNT-4: Due Diligence's two screens moved in unchanged (HIE-4, HIE-10); their old paths redirect here (App.tsx).
 * MNT-5: Voice of Customer's library is maintained elsewhere (a file in this repository) and shown read-only; the
 * component for an `elsewhere` thing is a view, never a control (STORIES_APP_MAINTENANCE.md, MNT-5 criterion 3).
 */
export const MAINTENANCE_TABS: Partial<Record<AppSlug, Record<string, MaintenanceTab>>> = {
  "channel-analytics": { example: ChannelAnalyticsExample },
  "due-diligence": { library: LibraryAdmin, queue: QueueAdmin, seed: SeedFileAdmin },
  "voice-of-customer": { library: VoiceOfCustomerLibrary }
};
